const parseHTML = (text, output = 'innerHTML') => {
  if (!text) return null;
  const DOM = new DOMParser().parseFromString(text, 'text/html').querySelector('body');
  const result = DOM[output];
  return result && result.trim ? result.trim() : result;
};

export default parseHTML;